module.exports = __webpack_public_path__ + "img/dashboard_account_icon.f5138095.svg";